<script>
import Layout from "@/layout/Main.vue";

export default {
	 components: {
		  Layout
	 },

    data() {
        return {
            faqs:{},
            errors: {},
            style: null,
           
        };
      
    },

    mounted() {
            this.fetchFaqs();
        },

	created() {
		  this.style = document.createElement('link')
		  this.style.setAttribute('rel', 'stylesheet')
		  this.style.setAttribute('href', '/design/terms-of-use.css')
		  document.head.appendChild(this.style)
	},

    beforeDestroy() {
        document.head.removeChild(this.style);
    },
    methods: {

        fetchFaqs() {
            let url = "about/faq";         
            this.$axios
            .get(url)
            .then((res) => {
                var responseData = res.data.data;
                console.log(res);
                this.faqs = responseData;  
                        
            })
            .catch((err) => console.log(err));
                
        },   

    }

}
</script>
<template>
    <layout>


    <div class="container-sm">
        <h3 class="fav fw-semibold">FAQ</h3>        

        <div class="accordion mb-5" role="tablist">
            <b-card no-body class="mb-2" v-for="faq in faqs" :key="faq.faq_id">
                <b-card-header header-tag="header" class="p-0" role="tab">
                    <a href="javascript:void(0);" v-b-toggle="'faq-' + faq.faq_id" class="btn btn-light btn-block w-100" style="border-radius: 5px; text-align: left;"><strong>{{ faq.title }}</strong></a>
                </b-card-header>
                <b-collapse :id="'faq-' + faq.faq_id" visible accordion="my-accordion" role="tabpanel">
                    <b-card-body>
                        <b-card-text>{{ faq.description }}</b-card-text>
                    </b-card-body>
                </b-collapse>
            </b-card>
        </div>
    </div>

    </layout>
</template>


<!-- <script>
@ is an alias to /src
import Layout from "@/layout/Main.vue";

export default {
	 components: {
		  Layout
	 },
data() {
         return {
            faqs:{},
            errors: {},

           
         };
      },
 created() {
         this.fetchFaqs();
      },

	 mounted() {
		  let style = document.createElement('link')
		  style.setAttribute('rel', 'stylesheet')
		  style.setAttribute('href', '/design/terms-of-use.css')
		  document.head.appendChild(style)
	 },
     methods: {

     fetchFaqs() {
            let url = "about/faq";         
            this.$axios
            .get(url)
            .then((res) => {
               var responseData = res.data.data;
               console.log(res);
               this.faqs = responseData;  
                     
                })
               .catch((err) => console.log(err));
               
         },}
}
</script>
<template>
    <layout>


 terms of use
 <div class="container-sm">
       <h3 class="fav fw-semibold">FAQS</h3>
       <div class="accordion" id="accordionExample" v-for="faq in faqs" :key="faq.faq_id">
        <div class="accordion-item">
            <h2 class="accordion-header" id="headingOne">
                <button class="accordion-button" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                    {{ faq.title }}
                </button>
            </h2>
            <div id="collapseOne" class="accordion-collapse collapse show" aria-labelledby="headingOne"
                data-bs-parent="#accordionExample">
                <div class="accordion-body">
                    <p>{{ faq.description }}</p>
                </div>
            </div>
        </div>
    </div>

        
    </div>

    </layout>
</template> -->